// import React from "react";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { ExportTable } from "./ExportTable";
import { useTransactionServerSideContext } from "../../context/transactionServerSide.context";
import { useDateContext } from "../../context/date.context";
import { useTranslation } from "react-i18next";
import { ThreeDashLoader } from "../../shared/loaders";
import { Row, Button } from "react-bootstrap";
import useSize from "../../hooks/useScreenSize";
import { useKeycloak } from "@react-keycloak/web";

export function TransactionsTable({ transactionsTableData }) {
  const { callFilterTransactionServerDetails, totalNumberOfTransactionsDetails, loadingFlagForDetails, setRefreshButtonDevice, refreshButtonDevice } =
    useTransactionServerSideContext();
  const { startDate, endDate, buttonPressed } = useDateContext();
  const { t } = useTranslation();
  const { windowSize } = useSize();
  const { initialized } = useKeycloak();

  const [isScreenSizeSmall, setIsScreenSizeSmall] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const transactionColumnNames = Object.getOwnPropertyNames(transactionsTableData[0] || []);

  const columns1 = transactionColumnNames.map((name) => ({
    name,
    selector: (row) => [row[name]],
    cell: (row) => <div className="font-weight-bold">{row[name]}</div>,
    sortable: true,
  }));

  const tableData = {
    columns: columns1,
    data: transactionsTableData,
  };

  const handlePageChange = (page) => {
    callFilterTransactionServerDetails(startDate, endDate, page, perPage);
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    callFilterTransactionServerDetails(startDate, endDate, page, newPerPage);
    setPerPage(newPerPage);
  };

  useEffect(() => {
    if (buttonPressed || refreshButtonDevice) {
      setPerPage(10);
    }
  }, [buttonPressed, refreshButtonDevice]);

  useEffect(() => {
    setTotalRows(totalNumberOfTransactionsDetails);
  }, [totalNumberOfTransactionsDetails]);

  useEffect(() => {
    setIsScreenSizeSmall(windowSize[0] < 818 || windowSize[1] < 818);
  }, [windowSize, initialized]);

  const numberForTotalRows = [10, 20, 50, 100, 500, 1000, 5000, 10000];

  return loadingFlagForDetails ? (
    ThreeDashLoader(t("loader.loadingTransactionData"))
  ) : (
    // DataTableExtensions => (AddOn Lib for Search & Export)
    <div>
      <ExportTable tableData={transactionsTableData}>
        <Row xs={12} sm={12} md={12}>
          <Button className={isScreenSizeSmall ? "wd-50p mg-x-auto" : "wd-15p mg-x-auto"} onClick={(e) => setRefreshButtonDevice(true)}>
            {t("general.refreshData")}
          </Button>
        </Row>
        <DataTableExtensions {...tableData} className="float-end">
          <DataTable
            columns={tableData.columns}
            data={tableData.data}
            defaultSortAsc={false}
            center={true}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationPerPage={perPage}
            highlightOnHover
            paginationRowsPerPageOptions={numberForTotalRows}
          />
        </DataTableExtensions>
      </ExportTable>
    </div>
  );
}
